import { ZodType } from "zod";

export const isRequired = (schema: ZodType) => {
  if (schema === undefined) {
    return false;
  }
  return !(schema.isOptional() || schema.isNullable());
};
